/**
 * Compose an integration's display label, appending "(disconnected)"
 * when the integration is not in the "connected" state.
 *
 * Any status value other than the literal string "connected" — including
 * null, undefined, "disconnected", "auth_failed", or unknown future
 * values — produces the suffixed form. This is intentional: users don't
 * need to distinguish between disconnected and auth_failed; only whether
 * the integration is live. Missing status is treated as not-connected
 * (fail-loud) so a serializer that forgets to surface
 * ahoy_connection_status produces a visible signal rather than silently
 * mislabeling every disconnected integration as connected.
 *
 * @example
 *   formatIntegrationLabel({name: "sarah@ahoy.ai", connectionStatus: "connected"})
 *   // => "sarah@ahoy.ai"
 *   formatIntegrationLabel({name: "sarah@ahoy.ai", connectionStatus: "disconnected"})
 *   // => "sarah@ahoy.ai (disconnected)"
 *   formatIntegrationLabel({name: "sarah@ahoy.ai"})
 *   // => "sarah@ahoy.ai (disconnected)"
 */
export interface IntegrationLabelInput {
  name: string;
  connectionStatus?: string | null;
}

export function formatIntegrationLabel(input: IntegrationLabelInput): string {
  if (input.connectionStatus === 'connected') {
    return input.name;
  }
  return `${input.name} (disconnected)`;
}
